import { render, staticRenderFns } from "./ContractsConfig.vue?vue&type=template&id=7b2d02bf&scoped=true&"
import script from "./ContractsConfig.vue?vue&type=script&lang=js&"
export * from "./ContractsConfig.vue?vue&type=script&lang=js&"
import style0 from "./ContractsConfig.vue?vue&type=style&index=0&id=7b2d02bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d02bf",
  null
  
)

export default component.exports